<template>
  <div class="item">
    <span class="name">语音用户数</span>
    <div class="count">6,39</div>
    <div class="subot-items">
      <div class="sub-item">
        <span class="sub-name">本月新增</span>
        <span class="sub-count add">+1201</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [],
  data () {
    return {}
  },
  computed: {},
  created () {},
  mounted () {},
  watch: {},
  methods: {},
  components: {}
}
</script>

<style scoped lang="stylus">
.item
  display: flex
  flex-direction: column
  .name
    color: rgba(255, 255, 255, 0.8)
    font-size: 16px
  .count
    color:rgba(255, 255, 255, 1)
    font-size: 22px
    margin: 3px 0
  .sub-item
    font-size: 12px
    .sub-name
      color: rgba(255, 255, 255, 0.6)
      margin-right: 4px

.item-small
  .name
    font-size: 12px
  .count
    font-size: 18px
  .sub-item
    font-size: 12px

.sub-item
  .sub-count.add
    color: rgba(255, 50, 108, 1)

</style>
